import { Injectable, inject } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Injectable({
    providedIn: 'root',
})
export class GtmConsentService {
    private readonly gtmService = inject(GoogleTagManagerService);

    ensureGtmLoaded(): void {
        if (this.isGoogleTagManagerLoaded()) {
            return;
        }

        void this.gtmService.addGtmToDom();
    }

    pushTag(item: Record<string, unknown>): Promise<void> {
        this.ensureGtmLoaded();
        return this.gtmService.pushTag(item);
    }

    private isGoogleTagManagerLoaded(): boolean {
        return (
            !!document.querySelector('script[src*="googletagmanager.com/gtm.js"]') ||
            typeof window.google_tag_manager !== 'undefined'
        );
    }
}
